import {getDiffInDays} from 'shared/lib/datetime';

import {IStatusPageView, IStatusPageViewMonitor} from '../model/IStatusPageView';

export const AVAILABILITY_THRESHOLD = {
    d1: 99.5,
    d7: 99.7,
    d30: 99.9,
};
export const SSL_DAYS_THRESHOLD = 14;
export const DOMAIN_DAYS_THRESHOLD = 30;

export type OverallKind = 'operational' | 'partial' | 'major' | 'paused';

const KNOWN_OVERALL: Record<string, OverallKind> = {
    operational: 'operational',
    partial_outage: 'partial',
    major_outage: 'major',
    paused: 'paused',
};

export const resolveOverall = (data: IStatusPageView): OverallKind => {
    const known = KNOWN_OVERALL[data.overall_status];
    if (known) {
        return known;
    }

    const monitors = data.monitors ?? [];
    if (monitors.length === 0) {
        return 'operational';
    }
    if (monitors.every((m) => m.status === 'paused')) {
        return 'paused';
    }
    const active = monitors.filter((m) => m.status !== 'paused');
    const down = active.filter((m) => m.status === 'down');
    if (down.length === 0) {
        return 'operational';
    }
    if (down.length === active.length) {
        return 'major';
    }
    return 'partial';
};

export const isAvailabilityOk = (value: number, threshold: number): boolean => value >= threshold;

export const daysUntil = (date: string): number => getDiffInDays(date, new Date());

export const sortMonitors = (monitors: IStatusPageViewMonitor[]): IStatusPageViewMonitor[] =>
    [...monitors].sort((a, b) => a.sort_order - b.sort_order);
